import ApiService from '../api.service'

type Params = {
    fileName: string
}

export const uploads = new ApiService<never, File, Params>('uploads')
